import React from 'react';

const FooterComponent: React.FC = () => {
    return (
        <footer className="mt-auto text-white-50">
            <p>Develop by <a href="https://devuweb.com" className="text-white">Devuweb</a>.</p>
        </footer>
    );
};
export default FooterComponent;
